export default __webpack_public_path__ + "static/media/saadiyat.56b0d22c.webp";